import { makeObservable, observable } from 'mobx';
import { RootStore } from '../../RootStore';

type AlertSeverity = 'success' | 'info' | 'warning' | 'error';

type Alert = {
  message: string;
  severity: AlertSeverity;
};

export class AlertStore {
  @observable public alert: Alert | null;
  private readonly parent: RootStore;

  constructor(parent: RootStore) {
    this.parent = parent;
    this.alert = null;

    makeObservable(this);
  }

  public showAlert = (message: string, severity: AlertSeverity = 'info'): void => {
    this.alert = { message, severity };
  };

  public hideAlert = (): void => {
    this.alert = null;
  };
}
